import React from 'react';
import { Alert, Button } from '@mui/material';
import { CreditCard as CreditCardIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { usePaymentWarningBanner } from '@/hooks/usePaymentWarningBanner';

export const PaymentWarningBanner: React.FC = () => {
  const { shouldShowBanner } = usePaymentWarningBanner();
  const navigate = useNavigate();

  const handleAddPaymentMethod = () => {
    navigate('/account/settings');
  };

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={{ mb: 1 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={handleAddPaymentMethod}
          startIcon={<CreditCardIcon />}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Add Payment Method
        </Button>
      }
    >
      Payment method required to ensure uninterrupted SimpleSUB service.
    </Alert>
  );
};
